// Close the native mobile drawer when navigating to a section on this page.
document.addEventListener('click', (event) => {
  const link = event.target.closest('header-drawer a[href]');
  if (!link) return;
  const destination = new URL(link.href, window.location.href);
  if (!destination.hash || destination.pathname !== window.location.pathname || destination.origin !== window.location.origin) return;
  const drawer = link.closest('header-drawer');
  if (typeof drawer.closeMenuDrawer !== 'function') return;
  const summary = drawer.querySelector('summary');
  drawer.closeMenuDrawer(event, summary);
  summary?.setAttribute('aria-expanded', 'false');
  const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
  if (target) {
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }
});

// Open a linked answer before the browser scrolls to it.
(() => {
  const openAnswer = (hash) => {
    let target;
    try {
      target = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch {
      return;
    }
    if (target?.matches('details.solvia-faq__item')) target.open = true;
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const destination = new URL(link.href, window.location.href);
    if (destination.origin === window.location.origin && destination.pathname === window.location.pathname && destination.hash) openAnswer(destination.hash);
  });
  window.addEventListener('hashchange', () => openAnswer(window.location.hash));
  openAnswer(window.location.hash);
})();
